import React from "react";
import Footer from "./Footer";
import Header from "./Header";

function About() {
  document.title="HR About Page"
  return (
    <div>
      <div>
        {/* custom menu */}
        <Header />
        {/* custom menu */}
        {/* about section */}
        <section className="about_section layout_padding mt-5">
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="img-box">
                  <img src="images/about-img.png" alt />
                </div>
              </div>
              <div className="col-md-5">
                <div className="detail-box">
                  <div className="custom_heading-container">
                    <h2>About HR</h2>
                  </div>
                  <p>
                    Full stack web developer, Digital Marketing Specialist,
                    UI/UX designer, Freelancer, Github Master.
                  </p>
                  <div>
                    <a href="https://hrportfolio.netlify.app/" target="_hero">About More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* end about section */}
        {/* info section */}

        {/* end info_section */}
        {/* footer section */}
        <Footer />
      </div>
    </div>
  );
}

export default About;
